import { resourcesRoot } from "from-start/scene/resources";
export function toPath(fileName) {
    return `${resourcesRoot}/1-run/${fileName}`;
}
//# sourceMappingURL=resource.js.map